import { svg } from "lit";
const icon = svg `<path d="M5.73434 40.1922L17.1919 24.1923H27.2534L40.6918 8.50398V40.1922H5.73434ZM7.23804 29.0923L5.41504 27.7654L13.2573 16.8077H23.2881L32.4034 6.19238L34.1149 7.68078L24.3419 19.0769H14.3919L7.23804 29.0923ZM10.1611 37.923H38.4226V14.623L28.2573 26.4615H18.3265L10.1611 37.923Z" fill="currentColor"/>`;
export default icon;
